import * as React from 'react'
import {ReactNode} from 'react'
import EventEmitterEx from './EventEmitterEx'
import {HttpCritical} from '../../../network/errors/baseHandling/HttpCritical'
import {HttpFatal} from '../../../network/errors/baseHandling/HttpFatal'
import {getErrorMessageForHttpStatus} from '../../../__NoAutomatedTests/common/util/Natutil'
import {Messages} from '../../../Messages'
import {SessionTimeOutError} from '../../../network/errors/SessionTimeOutError'
import {ERROR_ICON_MAP} from '../../../__NoAutomatedTests/components/error/NatGuestSystemErrorPage'
import {NavigateFunction} from 'react-router-dom'

interface SystemErrorHandlerProps {
    eventEmitter: EventEmitterEx
    navigate: NavigateFunction
    url: string
    loginUrl: string
}

export default class SystemErrorHandler extends React.Component<SystemErrorHandlerProps> {

    static displayName: string = 'SystemErrorHandler'

    constructor(props: Readonly<SystemErrorHandlerProps>) {
        super(props)
        this.handleSystemError = this.handleSystemError.bind(this)
    }

    componentDidMount(): void {
        this.props.eventEmitter.on('systemErrorOccured', this.handleSystemError)
    }

    componentWillUnmount(): void {
        this.props.eventEmitter.off('systemErrorOccured', this.handleSystemError)
    }

    handleSystemError(error: any): void {
        let message
        let addInfo

        if (error instanceof SessionTimeOutError) {
            window.location.href = `${this.props.loginUrl}?sessionTimeOut=1`
        } else {
            if (error instanceof HttpCritical) {
                message = getErrorMessageForHttpStatus((error as HttpCritical).status)

                const requestError = (error as HttpCritical).responseBody?.requestError
                if ((error as HttpCritical).status as number === 403 && requestError) {
                    message = requestError.message
                    addInfo = {
                        title: requestError.title,
                        icon: ERROR_ICON_MAP.get(requestError.title),
                    }
                }
            } else if (error instanceof HttpFatal) {
                message = getErrorMessageForHttpStatus((error as HttpFatal).status)
            } else {
                message = Messages.ESYCC0015.toString()
            }

            this.props.navigate(
                this.props.url,
                {state: {message: message, ...addInfo}},
            )
        }
    }

    render(): ReactNode {
        return null
    }
}
